import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SecretNotFoundErrorOptions = {
  secret: ObjectId;
};

export class SecretNotFoundError extends FleekError<SecretNotFoundErrorOptions> {
  public name = 'SecretNotFoundError';

  toString = () => {
    return 'Secret was not found.';
  };
}
